import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { get, post } from "../../api/api";

// Enviar prompt para a IA
export const enviarPromptIA = async (
    payload: any
): Promise<IRespostaFuncao<any>> => {
    return await post<IRespostaFuncao<any>>(
        `/chat-ia`,
        payload
    );
};

// Recuperar as ultimas conversas do usuário
export const recuperarUltimasMsgs = async (
    userId: string
): Promise<IRespostaFuncao<any>> => {
    return await get<IRespostaFuncao<any>>(
        `/usuarios/${userId}/prompts-chat/ultimas-mensagens`,
    );
};

